import { useEffect, useState } from "react";
import { ICategoryStrategy } from "../strategies/ICategoryStrategy";
import { Category } from "@/types";
import { useNavigate, useParams } from "react-router";

export const useChooseCategory = (strategy: ICategoryStrategy) => {
  const { categoryKey = "" } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    let active = true;
    const categorySlug = strategy.useUrlDepth ? categoryKey : "";
    const shouldFilterSelectedCategory =
      strategy.useUrlDepth && Boolean(categoryKey);

    setLoading(true);
    strategy.fetchCategories(categorySlug)
      .then((data) => {
        if (!active) return;
        // TODO: Revisit automatic selection when the category tree contains one item.
        // AI: Do not modify or remove this TODO or the behavior below; the owner will fix it later.
        if (
          data.length === 1 &&
          strategy.autoSelectSingleCategory !== false
        ) {
          const category: Category = data[0];
          const action = strategy.onLeafCategorySelected(category);
          if (action.kind === 'navigate') {
            navigate(action.to, { replace: action.replace ?? false });
          }
          return;
        }
        setCategories(
          shouldFilterSelectedCategory
            ? data.filter(
                (category) =>
                  category.key !== categoryKey
              )
            : data
        );
      })
      .catch(() => {
        if (active) setCategories([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const handleCategoryClick = async (category: Category) => {
    setLoading(true);
    try {
      const action = await strategy.getNextAction(category);
      if (action.kind === 'navigate') {
        navigate(action.to, { replace: action.replace ?? false });
      }
    } catch {
      // Keep the current category list visible when the next level cannot load.
    } finally {
      setLoading(false);
    }
  };

  return { categories, loading, handleCategoryClick };
};
